import React from 'react'
import FitOptionFullWidth from '@components/ui/FitOption/FitOptionFullWidth'
import { GIFT_CARD } from '@consts/index'

export type Choice = (typeof GIFT_CARD.radios)[number]['id']

type GiftCardMessagingOptionsProps = {
  handleOnChangeOption: (choice: Choice, index: number) => void
  choice: Choice
}

function GiftCardMessagingOptions({
  handleOnChangeOption,
  choice
}: GiftCardMessagingOptionsProps) {
  return (
    <>
      {GIFT_CARD.radios.map(({ step, value, id }, i) => (
        <FitOptionFullWidth
          key={id}
          value={value}
          step={step}
          selected={choice === id}
          id={id}
          onSelect={handleOnChangeOption}
          height={55}
          index={i}
        />
      ))}
    </>
  )
}

export default GiftCardMessagingOptions
